import { createApp } from 'vue';
import subscriptionInfo from '../vue/components/subscription-info.vue';
import subscriptionConfirmation from '../vue/components/subscription-confirmation.vue';
import searchBox from '../vue/components/search-box.vue';
import searchResult from '../vue/components/search-result.vue';

export function setupVue() {
    const app = createApp({
        components: {
            subscriptionInfo,
            subscriptionConfirmation,
            searchBox,
            searchResult
        }
    });
    app.config.compilerOptions.whitespace = 'preserve';
    app.mount('#app');
}
